import { userHasLevel } from "../../../engine/AuthRoute";
import { daysJsFormat, renderUserName, roles } from "../../../utils/constants";
import { Button, Space, Tag, Tooltip } from "antd";
import {
  mainTypesPrestation,
  typesPrestation,
} from "../../../utils/typesPrestation";
import { InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "../../../utils/dayjs";
import { Link } from "react-router-dom";
import { BiSearch } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import React from "react";

export const columnsLogList = logs => {
  let uniquebaseUrl = [];

  if (logs !== false) {
    const uniqueValuesSet = new Set();

    logs.map(obj => {
      uniqueValuesSet.add(obj.baseUrl);
    });

    let array = [...uniqueValuesSet];

    array.map(o => {
      uniquebaseUrl.push({ text: o, value: o });
    });
  }

  // One item is
  // { text: renderUserName(logs.user), value: logs.user._id  }

  // From logs.user

  let uniqueUser = logs
    .map(log => ({
      text: renderUserName(log.user),
      value: log.user._id,
    }))
    .filter(
      (user, index, self) =>
        index ===
        self.findIndex(t => t.value === user.value && t.text === user.text),
    );

  if (logs !== false) {
    const uniqueValuesSet = new Set();

    logs.map(obj => {
      uniqueValuesSet.add(obj.baseUrl);
    });

    let array = [...uniqueValuesSet];

    array.map(o => {
      uniquebaseUrl.push({ text: o, value: o });
    });
  }

  return [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: e => <span>{dayjs(e).format(daysJsFormat.full)}</span>,
      width: "15%",
      sorter: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    },
    {
      title: () => {
        return (
          <>
            <Tooltip
              title={<span>Correspond au type de données modifiées</span>}
              placement={"right"}
            >
              <InfoCircleOutlined style={{ color: "white" }} />
            </Tooltip>{" "}
            Ressource
          </>
        );
      },
      filters: uniquebaseUrl,
      onFilter: (value, record) => record.baseUrl.indexOf(value) === 0,
      dataIndex: "baseUrl",
      key: "baseUrl",
      width: "15%",
    },
    {
      title: () => {
        return (
          <>
            <Tooltip
              title={<span>Correspond au type d'action</span>}
              placement={"right"}
            >
              <InfoCircleOutlined style={{ color: "white" }} />
            </Tooltip>{" "}
            Méthode
          </>
        );
      },
      dataIndex: "method",
      key: "method",
      filters: [
        { value: "POST", text: "POST" },
        { value: "PATCH", text: "PATCH" },
        { value: "DELETE", text: "DELETE" },
      ],
      onFilter: (value, record) => record.method.indexOf(value) === 0,
      width: "15%",
    },
    {
      title: () => {
        return (
          <>
            <Tooltip
              title={<span>Correspond à l'id de la ressource impactée</span>}
              placement={"right"}
            >
              <InfoCircleOutlined style={{ color: "white" }} />
            </Tooltip>{" "}
            Item lié
          </>
        );
      },
      dataIndex: "entityId",
      render: entityId => <p>{entityId}</p>,
      key: "entityId",
      search: true,
      width: "15%",
    },
    {
      title: "Route",
      dataIndex: "route",
      render: route => <p>{route}</p>,
      key: "route",
      search: true,
      width: "15%",
    },

    {
      title: "Utilisateur",
      dataIndex: "user",
      key: "user",
      render: (user, record) => renderUserName(user),
      filters: uniqueUser,
      onFilter: (value, record) => {
        return record.user._id.indexOf(value) === 0;
      },
      width: "15%",
    },
    {
      title: "Adresse IP",
      dataIndex: "ipAddress",
      key: "ipAddress",
    },
    // {
    //   title: 'User Agent',
    //   dataIndex: 'userAgent',
    //   key: 'userAgent',
    // },
    // {
    //   title: 'User Agent',
    //   dataIndex: 'content',
    //   key: 'content',
    // },
  ];
};

export const inputsLogsList = ({
  searchState,
                                 setPagination,
  pagination,
  defaultPagination,
  loading,
  formRef,
  dispatchActionLogs,
  setSearchState,
}) => {
  return [
    {
      parentLabel: null,
      children: [
        {
          label: "Recherche par entitée",
          name: "entityId",
          value: searchState.entityId,
          type: "input",
          col: 8,
        },
        {
          type: "component",
          style: { textAlign: "left" },
          xl: 7,
          lg: 7,
          md: 7,
          sm: 12,
          xs: 24,
          label: "",
          component: () => (
            <Space
              align={"center"}
              style={{ width: "100%", justifyContent: "flex-end" }}
            >
              <Button
                loading={loading}
                size={"middle"}
                type={"primary"}
                style={{
                  marginTop: "-6px",
                  width: "100%",
                  fontWeight: "bold",
                }}
                icon={<BiSearch style={{ marginTop: "0px" }} size={25} />}
                onClick={() => formRef.current.submit()}
              >
                Rechercher
              </Button>
              <Button
                style={{
                  marginTop: "-7px",
                  width: "100%",
                  color: colorPrimary,
                  fontWeight: "bold",
                }}
                icon={<GrPowerReset style={{ marginTop: "-3px" }} size={15} />}
                onClick={async () => {
                  localStorage.removeItem("logsSearcher");

                  setSearchState({});

                  formRef.current.resetFields(); // Reset the form fields using the ref

                  formRef.current.setFieldsValue({
                    entityId: "",
                  });
                  // formRef.current.setFieldsValue(initialValuesForm);
                  setPagination(defaultPagination);
                  await dispatchActionLogs();
                }}
                size="middle"
                type={"text"}
              >
                Réinitialiser
              </Button>
            </Space>
          ),
        },
      ],
    },
  ];
};
